///////////////////////////////////////////////////
//dl-common.js
///////////////////////////////////////////////////
let GuideFlg = false;
window.addEventListener("keydown", function (e) {
  if (e.keyCode == 71) {
    //g
    toggleGuide();
  }
});
function toggleGuide() {
  if (GuideFlg) {
    GuideFlg = false;
    DL_removeClass(document.body, "is-guide");
  } else {
    GuideFlg = true;
    DL_addClass(document.body, "is-guide");
  }
}
// ************************************** 画像遅延
class DL_LazyBgi {
  constructor(selector) {
    this.elements = document.querySelectorAll(selector);
    this.elements.forEach((element) => {
      element.src = element.getAttribute("data-bgi");
      element.style.backgroundImage = "url( " + element.src + " )";
    });
  }
}
new DL_LazyBgi(".dl-js-lazy_bgi");

// ************************************** スクロールアニメーション
class DL_ScrollAction {
  constructor(selector) {
    this.elements = document.querySelectorAll(selector);

    if (this.elements.length === 0) {
      return;
    } else {
      this.borderTop = 0;
      this.borderMiddle = 0.5;
      this.borderBottom = 1;
      this.flg = false;
      this.remove = true;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener("scroll", this.onScrollHandler, false);
      window.addEventListener("resize", this.onResize.bind(this));
      DL_removeClass(this.elements, "sa-active");
      this.init();
    }
  }
  init() {
    this.array = [];
    this.count = 0;
    this.windowTop = window.innerHeight * this.borderTop;
    this.windowMiddle = window.innerHeight * this.borderMiddle;
    this.windowBottom = window.innerHeight * this.borderBottom;
    this.elements.forEach((element) => {
      const sa = element;
      sa.top = DL_offsetTop(sa);
      sa.height = sa.offsetHeight;
      sa.topHeight = sa.top + sa.height;
      sa.bottom = sa.top + sa.height;
      sa.progress = 0;
      sa.flg = false;
      this.array.push(sa);
    });
    this.onScroll();
  }
  resetArray() {
    this.array = [];
    this.elements.forEach((element) => {
      const sa = element;
      sa.top = DL_offsetTop(sa);
      sa.height = sa.offsetHeight;
      sa.topHeight = sa.top + sa.height;
      sa.bottom = sa.top + sa.height;
      sa.progress = 0;
      sa.flg = false;
      this.array.push(sa);
    });
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.areaTop = Math.floor(scrollTop + this.windowTop);
    this.areaMiddle = Math.floor(scrollTop + this.windowMiddle);
    this.areaBottom = Math.floor(scrollTop + this.windowBottom);
    this.areaHeight = this.areaBottom - this.areaTop;
    this.areaHalf = this.areaBottom - this.areaMiddle;
    this.resetArray();

    this.array.forEach((element) => {
      var sa = element;
      let bottom = sa.bottom;
      // console.log(this.areaBottom , bottom, sa.top, sa.classList.contains('dl-footer__wrap'), sa)
      if (
        this.areaBottom > sa.top &&
        sa.classList.contains("dl-footer__wrap")
      ) {
        DL_addClass(sa, "sa-active");
      } else if (
        !sa.classList.contains("dl-footer__wrap") &&
        this.areaBottom >= sa.top &&
        this.areaTop < bottom
      ) {
        DL_addClass(sa, "sa-active");
        sa.progress = Math.round(
          ((this.areaBottom - sa.top) / (this.areaHeight + sa.height)) * 100
        );
        sa.progressHalf = Math.round(
          ((this.areaBottom - sa.top) / (this.areaHalf + sa.height / 2)) * 100
        );

        if (DL_hasClass(sa, "dl-js-sa__image")) {
          var scale = sa.getAttribute("data-scale");
          var range = scale * 100 - 100;
          sa.style.transform =
            "translate3d(0px, " +
            (range / 2 - range * (sa.progress / 100)) +
            "%, 0px) scale(" +
            scale +
            ")";
        }

        if (DL_hasClass(sa, "dl-js-sa__float")) {
          var rangeY = sa.getAttribute("data-rangeY");
          var rangeX = sa.getAttribute("data-rangeX");
          var adjust =
            Math.round(Math.cos((sa.progressHalf * Math.PI) / 180) * 100) / 100;
          var stop = JSON.parse(sa.getAttribute("data-stop").toLowerCase());
          if (stop) {
            sa.style.transform =
              "translate3d(" +
              Math.round(rangeX * Math.max(0, adjust) * 100) / 100 +
              "%, " +
              Math.round(rangeY * Math.max(0, adjust) * 100) / 100 +
              "%, 0px)";
          } else {
            sa.style.transform =
              "translate3d(" +
              Math.round(rangeX * adjust * 100) / 100 +
              "%, " +
              Math.round(rangeY * adjust * 100) / 100 +
              "%, 0px)";
          }
        }

        if (this.remove == false) {
          if (sa.flg == false) {
            sa.flg = true;
            this.count++;
            if (this.count == this.array.length) {
              this.flg = false;
            }
          }
        }
      } else {
        if (this.remove) {
          if (sa.getAttribute("data-remove")) {
            if (JSON.parse(sa.getAttribute("data-remove").toLowerCase())) {
              DL_removeClass(sa, "sa-active");
            }
          } else {
            DL_removeClass(sa, "sa-active");
          }
        }
      }
    });
  }
  onResize() {
    this.init();
  }
}

new DL_ScrollAction(".dl-js-sa");

// ************************************** セクションチェック
class DL_SectionFunc {
  constructor(selector) {
    this.elements = document.querySelectorAll(selector);
    if (this.elements.length === 0) {
      return;
    } else {
      this.flg = false;
      this.SectionIndex = 0;
      this.SectionIndexAfter = 0;
      this.array = [];
      this.border = window.innerHeight * 0.5;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener("scroll", this.onScrollHandler, false);
      window.addEventListener("resize", this.onResize.bind(this));
      DL_removeClass(this.elements, "is-active");
      this.init();
    }
  }
  init() {
    this.elements.forEach((element) => {
      this.array.push(DL_offsetTop(element));
    });

    this.onScroll();
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.elements.forEach((element, index) => {
      if (scrollTop + this.border >= this.array[index]) {
        this.SectionIndex = index;
      }
    });
    if (this.SectionIndexAfter != this.SectionIndex) {
      DL_removeClass(this.elements, "is-active");
      DL_addClass(this.elements[this.SectionIndex], "is-active");
      if (DL_hasClass(this.elements[this.SectionIndex], "is-invert")) {
        DL_addClass(document.body, "is-invert");
      } else {
        DL_removeClass(document.body, "is-invert");
      }

      // if (DL_hasClass(this.elements[this.SectionIndex], "is-wh")) {
      //   DL_addClass(document.body, "is-wh");
      // } else {
      //   DL_removeClass(document.body, "is-wh");
      // }

      if (DL_hasClass(this.elements[this.SectionIndex], "is-transparent")) {
        DL_addClass(document.body, "is-transparent");
      } else {
        DL_removeClass(document.body, "is-transparent");
      }
    }

    this.SectionIndexAfter = this.SectionIndex;
  }
  onResize() {
    this.init();
  }
}

new DL_SectionFunc("section");

///////////////////////////////////////////////////
// utility function
///////////////////////////////////////////////////

function DL_media() {
  let media = "PC";
  if (window.innerWidth > 1000) {
    media = "PC";
  } else if (window.innerWidth > 680) {
    media = "TB";
  } else {
    media = "SP";
  }
  return media;
}
window.DL_media = DL_media;

function DL_hasClass(_target, _class) {
  return _target.classList.contains(_class);
}
window.DL_hasClass = DL_hasClass;

function DL_addClass(_target, _class) {
  if (_target.length) {
    if (Array.isArray(_class)) {
      for (var i = 0; i < _target.length; i++) {
        for (var j = 0; j < _class.length; j++) {
          _target[i].classList.add(_class[j]);
        }
      }
    } else {
      for (var i = 0; i < _target.length; i++) {
        _target[i].classList.add(_class);
      }
    }
  } else {
    if (Array.isArray(_class)) {
      for (var i = 0; i < _class.length; i++) {
        _target.classList.add(_class[i]);
      }
    } else {
      _target.classList.add(_class);
    }
  }
}
window.DL_addClass = DL_addClass;

function DL_removeClass(_target, _class) {
  if (_target.length) {
    if (Array.isArray(_class)) {
      for (var i = 0; i < _target.length; i++) {
        for (var j = 0; j < _class.length; j++) {
          _target[i].classList.remove(_class[j]);
        }
      }
    } else {
      for (var i = 0; i < _target.length; i++) {
        _target[i].classList.remove(_class);
      }
    }
  } else {
    if (Array.isArray(_class)) {
      for (var i = 0; i < _class.length; i++) {
        _target.classList.remove(_class[i]);
      }
    } else {
      _target.classList.remove(_class);
    }
  }
}
window.DL_removeClass = DL_removeClass;

function DL_offsetTop(_target) {
  var rect = _target.getBoundingClientRect();
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return rect.top + scrollTop;
}
window.DL_offsetTop = DL_offsetTop;

function DL_offsetLeft(_target) {
  var rect = _target.getBoundingClientRect();
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  return rect.left + scrollLeft;
}
window.DL_offsetLeft = DL_offsetLeft;

function DL_fadeIn(_target, _time, _callback) {
  _target.style.display = "block";
  _target.style.opacity = 0;

  var start = performance.now();
  if (!_time) {
    _time = 500;
  }
  requestAnimationFrame(function tick(timestamp) {
    var easing = (timestamp - start) / _time;
    _target.style.opacity = Math.min(easing, 1);
    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      if (_callback) {
        _callback();
      }
    }
  });
}
window.DL_fadeIn = DL_fadeIn;

function DL_fadeOut(_target, _time, _callback) {
  var start = performance.now();
  if (!_time) {
    _time = 500;
  }
  requestAnimationFrame(function tick(timestamp) {
    var easing = (timestamp - start) / _time;
    _target.style.opacity = Math.max(1 - easing, 0);
    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      _target.style.opacity = 0;
      _target.style.display = "none";
      if (_callback) {
        _callback();
      }
    }
  });
}
window.DL_fadeOut = DL_fadeOut;

function DL_slideDown(element, duration = 300) {
  element.style.display = "block";
  element.style.overflow = "hidden";
  element.style.height = "0";

  let totalHeight = 0;
  let startTime = null;

  function animate(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = timestamp - startTime;

    totalHeight = (progress / duration) * element.scrollHeight;
    element.style.height = totalHeight + "px";

    if (progress < duration) {
      requestAnimationFrame(animate);
    } else {
      element.style.height = "auto";
      DL_selfResize();
    }
  }

  requestAnimationFrame(animate);
}
window.DL_slideDown = DL_slideDown;

function DL_slideUp(element, duration = 300) {
  let totalHeight = element.scrollHeight;
  let startTime = null;

  function animate(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = timestamp - startTime;

    totalHeight = (1 - progress / duration) * element.scrollHeight;
    element.style.height = totalHeight + "px";

    if (progress < duration) {
      requestAnimationFrame(animate);
    } else {
      element.style.display = "none";
      element.style.overflow = "";
      element.style.height = "";
      DL_selfResize();
    }
  }

  requestAnimationFrame(animate);
}
window.DL_slideUp = DL_slideUp;

function DL_alpha1(_target, _time, _callback) {
  // _target.style.display = "block";
  _target.style.opacity = 0;

  var start = performance.now();
  if (!_time) {
    _time = 500;
  }
  requestAnimationFrame(function tick(timestamp) {
    var easing = (timestamp - start) / _time;
    _target.style.opacity = Math.min(easing, 1);
    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      if (_callback) {
        _callback();
      }
    }
  });
}
window.DL_alpha1 = DL_alpha1;

function DL_alpha0(_target, _time, _callback) {
  var start = performance.now();
  if (!_time) {
    _time = 500;
  }
  requestAnimationFrame(function tick(timestamp) {
    var easing = (timestamp - start) / _time;
    _target.style.opacity = Math.max(1 - easing, 0);
    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      _target.style.opacity = 0;
      // _target.style.display = "none";
      if (_callback) {
        _callback();
      }
    }
  });
}
window.DL_alpha0 = DL_alpha0;

// ゼロパッデング　NUM=値 LEN=桁数
function DL_zeroPadding(NUM, LEN) {
  return (Array(LEN).join("0") + NUM).slice(-LEN);
}
window.DL_zeroPadding = DL_zeroPadding;

function DL_selfResize() {
  var resizeEvent = window.document.createEvent("UIEvents");
  resizeEvent.initUIEvent("", true, false, window, 0);
  window.dispatchEvent(resizeEvent);
}
window.DL_selfResize = DL_selfResize;
// DL_selfResize();

// class DL_ScrollAction extends HTMLElement {
//   constructor() {
//     super();
//     this.borderTop = 0;
//     this.borderMiddle = 0.5;
//     this.borderBottom = 1;
//     this.windowTop = window.innerHeight * this.borderTop;
//     this.windowMiddle = window.innerHeight * this.borderMiddle;
//     this.windowBottom = window.innerHeight * this.borderBottom;
//     this.flg = false;
//     this.remove = true; //trueで毎回
//     DL_removeClass(this, "sa-active");
//     this.onScrollHandler = this.onScroll.bind(this);
//     window.addEventListener('scroll', this.onScrollHandler, false);
//     window.addEventListener('resize', this.onResize.bind(this));
//     this.init();
//     this.onScroll();
//   }
//   init() {
//     this.top = DL_offsetTop(this);
//     this.height = this.offsetHeight;
//     this.topHeight = this.top + this.height;
//     this.bottom = this.top + this.height;
//     this.progress = 0;
//     this.flg = false;
//   }
//   onScroll() {
//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//     this.areaTop = Math.floor(scrollTop + this.windowTop);
//     this.areaMiddle = Math.floor(scrollTop + this.windowMiddle);
//     this.areaBottom = Math.floor(scrollTop + this.windowBottom);
//     this.areaHeight = this.areaBottom - this.areaTop;
//     this.areaHalf = this.areaBottom - this.areaMiddle;
//     if (this.areaBottom >= this.top && this.areaTop <= this.bottom) {
//       DL_addClass(this, "sa-active");
//       this.progress = Math.round(((this.areaBottom - this.top) / (this.areaHeight + this.height)) * 100);
//       this.progressHalf = Math.round(((this.areaBottom - this.top) / (this.areaHalf + this.height / 2)) * 100);
//       if (DL_hasClass(this, "dl-js-sa__image")) {
//         var scale = this.getAttribute("data-scale");
//         var range = scale * 100 - 100;
//         this.style.transform = "translate3d(0px, " + (range / 2 - range * (this.progress / 100)) + "%, 0px) scale(" + scale + ")";
//       }
//       if (DL_hasClass(this, "dl-js-sa__float")) {
//         var rangeY = this.getAttribute("data-rangeY");
//         var rangeX = this.getAttribute("data-rangeX");
//         var adjust = Math.round(Math.cos((this.progressHalf * Math.PI) / 180) * 100) / 100;
//         var stop = JSON.parse(this.getAttribute("data-stop").toLowerCase());
//         if (stop) {
//           this.style.transform = "translate3d(" + Math.round(rangeX * Math.max(0, adjust) * 100) / 100 + "%, " + Math.round(rangeY * Math.max(0, adjust) * 100) / 100 + "%, 0px)";
//         } else {
//           this.style.transform = "translate3d(" + Math.round(rangeX * adjust * 100) / 100 + "%, " + Math.round(rangeY * adjust * 100) / 100 + "%, 0px)";
//         }
//       }
//     } else {
//       if (this.remove) {
//         DL_removeClass(this, "sa-active");
//       }
//     }
//   }
//   onResize() {
//     this.init();
//   }
// }
// customElements.define('dl-js-sa', DL_ScrollAction);
// function DL_addClass(_target, _class) {
//   if (_target.length) {
//     if (Array.isArray(_class)) {
//       for (var i = 0; i < _target.length; i++) {
//         for (var j = 0; j < _class.length; j++) {
//           _target[i].classList.add(_class[j]);
//         }
//       }
//     } else {
//       for (var i = 0; i < _target.length; i++) {
//         _target[i].classList.add(_class);
//       }
//     }
//   } else {
//     if (Array.isArray(_class)) {
//       for (var i = 0; i < _class.length; i++) {
//         _target.classList.add(_class[i]);
//       }
//     } else {
//       _target.classList.add(_class);
//     }
//   }
// }

// window.DL_addClass = DL_addClass;

// let Body, Root, Header, Footer, Main, Section;
// let Media = "PC";
// const TB = 1000;
// const SP = 680;
// let LoadFlg = false;
// let CoverFlg = false;
// window.addEventListener("load", function () {
//   addClass(document.body, "is-load");

//   if (!getCookie("visited")) {
//     CoverFlg = true;
//     setCookie("visited", true, 1);
//   } else {
//     CoverFlg = false;
//   }

//   InitFunc.Load();
// });

// const InitFunc = {};
// InitFunc.Load = function () {
//   Body = document.body;
//   Root = document.querySelector(":root");
//   Header = document.querySelector("header");
//   Footer = document.querySelector("footer");
//   Main = document.querySelector(".dl-kinto__top");
//   Section = document.querySelectorAll(".dl-kinto__top section");

//   //LazyBgi
//   if (document.getElementsByClassName("dl-js-lazy_bgi").length) {
//     var lazy_bgi = document.querySelectorAll(".dl-js-lazy_bgi");
//     for (var i = 0; i < lazy_bgi.length; i++) {
//       var bgi = lazy_bgi[i].getAttribute("data-bgi");
//       lazy_bgi[i].style.backgroundImage = "url( " + bgi + " )";
//     }
//   }
//   InitFunc.Set();
//   // addClass(Body, "is-load")
//   LoadFlg = true;
// };
// InitFunc.Set = function () {
//   //DataSet
//   Window.h = window.innerHeight;
//   // Window.h = document.documentElement.clientHeight;
//   Window.w = window.innerWidth;
//   // Header.h = Header.offsetHeight;
//   // Header.w = Header.offsetWidth;
//   // Footer.h = Footer.offsetHeight;
//   // Footer.w = Footer.offsetWidth;
//   // Root.style.setProperty('--HeaderHeight', Header.h + 'px');
//   // alert(Window.h)
//   if (Window.w > TB) {
//     Media = "PC";
//   } else if (Window.w > SP) {
//     Media = "TB";
//   } else {
//     Media = "SP";
//   }
// };

// // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// // [Usefull] ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// function hasClass(_target, _class) {
//   return _target.classList.contains(_class);
// }

// function addClass(_target, _class) {
//   if (_target.length) {
//     if (Array.isArray(_class)) {
//       for (var i = 0; i < _target.length; i++) {
//         for (var j = 0; j < _class.length; j++) {
//           _target[i].classList.add(_class[j]);
//         }
//       }
//     } else {
//       for (var i = 0; i < _target.length; i++) {
//         _target[i].classList.add(_class);
//       }
//     }
//   } else {
//     if (Array.isArray(_class)) {
//       for (var i = 0; i < _class.length; i++) {
//         _target.classList.add(_class[i]);
//       }
//     } else {
//       _target.classList.add(_class);
//     }
//   }
// }

// function removeClass(_target, _class) {
//   if (_target.length) {
//     if (Array.isArray(_class)) {
//       for (var i = 0; i < _target.length; i++) {
//         for (var j = 0; j < _class.length; j++) {
//           _target[i].classList.remove(_class[j]);
//         }
//       }
//     } else {
//       for (var i = 0; i < _target.length; i++) {
//         _target[i].classList.remove(_class);
//       }
//     }
//   } else {
//     if (Array.isArray(_class)) {
//       for (var i = 0; i < _class.length; i++) {
//         _target.classList.remove(_class[i]);
//       }
//     } else {
//       _target.classList.remove(_class);
//     }
//   }
// }

// function offsetTop(_target) {
//   var rect = _target.getBoundingClientRect();
//   var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//   return rect.top + scrollTop;
// }

// function offsetLeft(_target) {
//   var rect = _target.getBoundingClientRect();
//   var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
//   return rect.left + scrollLeft;
// }

// function fadeIn(_target, _time, _callback) {
//   _target.style.display = "block";
//   _target.style.opacity = 0;

//   var start = performance.now();
//   if (!_time) {
//     _time = 500;
//   }
//   requestAnimationFrame(function tick(timestamp) {
//     var easing = (timestamp - start) / _time;
//     _target.style.opacity = Math.min(easing, 1);
//     if (easing < 1) {
//       requestAnimationFrame(tick);
//     } else {
//       if (_callback) {
//         _callback();
//       }
//     }
//   });
// }

// function fadeOut(_target, _time, _callback) {
//   var start = performance.now();
//   if (!_time) {
//     _time = 500;
//   }
//   requestAnimationFrame(function tick(timestamp) {
//     var easing = (timestamp - start) / _time;
//     _target.style.opacity = Math.max(1 - easing, 0);
//     if (easing < 1) {
//       requestAnimationFrame(tick);
//     } else {
//       _target.style.opacity = 0;
//       _target.style.display = "none";
//       if (_callback) {
//         _callback();
//       }
//     }
//   });
// }

// function slideUp(_target, _time, _callback) {
//   var start = performance.now();
//   var height = _target.getAttribute("data-height");
//   if (!_time) {
//     _time = 500;
//   }
//   requestAnimationFrame(function tick(timestamp) {
//     var easing = (timestamp - start) / _time;
//     _target.style.height = Math.max(1 - easing, 0) * height + "px";
//     if (easing < 1) {
//       requestAnimationFrame(tick);
//     } else {
//       _target.style.height = 0;
//       _target.style.display = "none";
//       if (_callback) {
//         _callback();
//       }
//     }
//   });
// }

// function slideDown(_target, _time, _callback) {
//   _target.style.display = "block";
//   _target.style.height = 0;
//   var start = performance.now();
//   var height = _target.getAttribute("data-height");

//   if (!_time) {
//     _time = 500;
//   }
//   requestAnimationFrame(function tick(timestamp) {
//     var easing = (timestamp - start) / _time;
//     _target.style.height = Math.min(easing, 1) * height + "px";
//     if (easing < 1) {
//       requestAnimationFrame(tick);
//     } else {
//       _target.style.height = height + "px";
//       _target.style.display = "block";
//       if (_callback) {
//         _callback();
//       }
//     }
//   });
// }

// function tile(_target, _num) {
//   if (!_num) {
//     var array = [];
//     for (var i = 0; i < _target.length; i++) {
//       _target[i].style.height = "auto";
//       array.push(_target[i].offsetHeight);
//     }
//     var max = Math.max.apply(null, array);
//     for (var i = 0; i < _target.length; i++) {
//       _target[i].style.height = max + "px";
//     }
//   } else {
//     var array = [];
//     var arrayIn = [];
//     var maxArray = [];
//     var idx = 0;
//     for (var i = 0; i < _target.length; i++) {
//       if (i % _num == 0) {
//         arrayIn = [];
//         array.push(arrayIn);
//       }
//       _target[i].style.height = "auto";
//       arrayIn.push(_target[i].offsetHeight);
//     }

//     for (var i = 0; i < array.length; i++) {
//       maxArray.push(Math.max.apply(null, array[i]));
//     }

//     for (var i = 0; i < _target.length; i++) {
//       if (i % _num == 0) {
//         var max = maxArray[i / _num];
//       }
//       _target[i].style.height = max + "px";
//     }
//   }
// }

// // ゼロパッデング　NUM=値 LEN=桁数
// function zeroPadding(NUM, LEN) {
//   return (Array(LEN).join("0") + NUM).slice(-LEN);
// }

// // Cookieに初回訪問フラグをセットする
// function setCookie(name, value, days) {
//   var expires = "";
//   if (days) {
//     var date = new Date();
//     date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
//     expires = "; expires=" + date.toUTCString();
//   }
//   document.cookie = name + "=" + (value || "") + expires + "; path=/";
// }

// // Cookieから初回訪問フラグを取得する
// function getCookie(name) {
//   var nameEQ = name + "=";
//   var ca = document.cookie.split(";");
//   for (var i = 0; i < ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) == " ") c = c.substring(1, c.length);
//     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
//   }
//   return null;
// }

// // cookieを削除する関数
// function deleteCookie(name) {
//   document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
// }
